import { createSelector as cr } from '@app/packages/memoselector/memoselector'

export const createSelector = cr
